import { defineMessages } from 'react-intl-next';

export const colorNames: {
    blue: {
        defaultMessage: string;
        description: string;
        id: string;
    }; boldBlue: {
        defaultMessage: string;
        description: string;
        id: string;
    }; boldGray: {
        defaultMessage: string;
        description: string;
        id: string;
    }; boldGreen: {
        defaultMessage: string;
        description: string;
        id: string;
    }; boldLime: {
        defaultMessage: string;
        description: string;
        id: string;
    }; boldMagenta: {
        defaultMessage: string;
        description: string;
        id: string;
    }; boldOrange: {
        defaultMessage: string;
        description: string;
        id: string;
    }; boldPurple: {
        defaultMessage: string;
        description: string;
        id: string;
    }; boldRed: {
        defaultMessage: string;
        description: string;
        id: string;
    }; boldTeal: {
        defaultMessage: string;
        description: string;
        id: string;
    }; boldYellow: {
        defaultMessage: string;
        description: string;
        id: string;
    }; defaultBlue: {
        defaultMessage: string;
        description: string;
        id: string;
    }; defaultWhite: {
        defaultMessage: string;
        description: string;
        id: string;
    }; gray: {
        defaultMessage: string;
        description: string;
        id: string;
    }; green: {
        defaultMessage: string;
        description: string;
        id: string;
    }; lightBlue: {
        defaultMessage: string;
        description: string;
        id: string;
    }; lightGray: {
        defaultMessage: string;
        description: string;
        id: string;
    }; lightGreen: {
        defaultMessage: string;
        description: string;
        id: string;
    }; lightLime: {
        defaultMessage: string;
        description: string;
        id: string;
    }; lightMagenta: {
        defaultMessage: string;
        description: string;
        id: string;
    }; lightOrange: {
        defaultMessage: string;
        description: string;
        id: string;
    }; lightPurple: {
        defaultMessage: string;
        description: string;
        id: string;
    }; lightRed: {
        defaultMessage: string;
        description: string;
        id: string;
    }; lightTeal: {
        defaultMessage: string;
        description: string;
        id: string;
    }; lightYellow: {
        defaultMessage: string;
        description: string;
        id: string;
    }; lime: {
        defaultMessage: string;
        description: string;
        id: string;
    }; magenta: {
        defaultMessage: string;
        description: string;
        id: string;
    }; orange: {
        defaultMessage: string;
        description: string;
        id: string;
    }; purple: {
        defaultMessage: string;
        description: string;
        id: string;
    }; red: {
        defaultMessage: string;
        description: string;
        id: string;
    }; subtleBlue: {
        defaultMessage: string;
        description: string;
        id: string;
    }; subtleGray: {
        defaultMessage: string;
        description: string;
        id: string;
    }; subtleGreen: {
        defaultMessage: string;
        description: string;
        id: string;
    }; subtleLime: {
        defaultMessage: string;
        description: string;
        id: string;
    }; subtleMagenta: {
        defaultMessage: string;
        description: string;
        id: string;
    }; subtleOrange: {
        defaultMessage: string;
        description: string;
        id: string;
    }; subtlePurple: {
        defaultMessage: string;
        description: string;
        id: string;
    }; subtleRed: {
        defaultMessage: string;
        description: string;
        id: string;
    }; subtleTeal: {
        defaultMessage: string;
        description: string;
        id: string;
    }; subtleYellow: {
        defaultMessage: string;
        description: string;
        id: string;
    }; teal: {
        defaultMessage: string;
        description: string;
        id: string;
    }; white: {
        defaultMessage: string;
        description: string;
        id: string;
    }; yellow: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	defaultWhite: {
		id: 'company-hub.color-picker.default-white',
		description: 'Name of default white color',
		defaultMessage: 'Default white',
	},
	white: {
		id: 'company-hub.color-picker.white',
		description: 'Name of white color',
		defaultMessage: 'White',
	},
	lightGray: {
		id: 'company-hub.color-picker.light-gray',
		description: 'Name of light gray color',
		defaultMessage: 'Light gray',
	},
	lightBlue: {
		id: 'company-hub.color-picker.light-blue',
		description: 'Name of light blue color',
		defaultMessage: 'Light blue',
	},
	lightPurple: {
		id: 'company-hub.color-picker.light-purple',
		description: 'Name of light purple color',
		defaultMessage: 'Light purple',
	},
	lightMagenta: {
		id: 'company-hub.color-picker.light-magenta',
		description: 'Name of light magenta color',
		defaultMessage: 'Light magenta',
	},
	lightRed: {
		id: 'company-hub.color-picker.light-red',
		description: 'Name of light red color',
		defaultMessage: 'Light red',
	},
	lightOrange: {
		id: 'company-hub.color-picker.light-orange',
		description: 'Name of light orange color',
		defaultMessage: 'Light orange',
	},
	lightYellow: {
		id: 'company-hub.color-picker.light-yellow',
		description: 'Name of light yellow color',
		defaultMessage: 'Light yellow',
	},
	lightLime: {
		id: 'company-hub.color-picker.light-lime',
		description: 'Name of light lime color',
		defaultMessage: 'Light lime',
	},
	lightGreen: {
		id: 'company-hub.color-picker.light-green',
		description: 'Name of light green color',
		defaultMessage: 'Light green',
	},
	lightTeal: {
		id: 'company-hub.color-picker.light-teal',
		description: 'Name of light teal color',
		defaultMessage: 'Light teal',
	},
	subtleGray: {
		id: 'company-hub.color-picker.subtle-gray',
		description: 'Name of subtle gray color',
		defaultMessage: 'Subtle gray',
	},
	subtleBlue: {
		id: 'company-hub.color-picker.subtle-blue',
		description: 'Name of subtle blue color',
		defaultMessage: 'Subtle blue',
	},
	subtlePurple: {
		id: 'company-hub.color-picker.subtle-purple',
		description: 'Name of subtle purple color',
		defaultMessage: 'Subtle purple',
	},
	subtleMagenta: {
		id: 'company-hub.color-picker.subtle-magenta',
		description: 'Name of subtle magenta color',
		defaultMessage: 'Subtle magenta',
	},
	subtleRed: {
		id: 'company-hub.color-picker.subtle-red',
		description: 'Name of subtle red color',
		defaultMessage: 'Subtle red',
	},
	subtleOrange: {
		id: 'company-hub.color-picker.subtle-orange',
		description: 'Name of subtle orange color',
		defaultMessage: 'Subtle orange',
	},
	subtleYellow: {
		id: 'company-hub.color-picker.subtle-yellow',
		description: 'Name of subtle yellow color',
		defaultMessage: 'Subtle yellow',
	},
	subtleLime: {
		id: 'company-hub.color-picker.subtle-lime',
		description: 'Name of subtle lime color',
		defaultMessage: 'Subtle lime',
	},
	subtleGreen: {
		id: 'company-hub.color-picker.subtle-green',
		description: 'Name of subtle green color',
		defaultMessage: 'Subtle green',
	},
	subtleTeal: {
		id: 'company-hub.color-picker.subtle-teal',
		description: 'Name of subtle teal color',
		defaultMessage: 'Subtle teal',
	},
	gray: {
		id: 'company-hub.color-picker.gray',
		description: 'Name of gray color',
		defaultMessage: 'Gray',
	},
	blue: {
		id: 'company-hub.color-picker.blue',
		description: 'Name of blue color',
		defaultMessage: 'Blue',
	},
	purple: {
		id: 'company-hub.color-picker.purple',
		description: 'Name of purple color',
		defaultMessage: 'Purple',
	},
	magenta: {
		id: 'company-hub.color-picker.magenta',
		description: 'Name of magenta color',
		defaultMessage: 'Magenta',
	},
	red: {
		id: 'company-hub.color-picker.red',
		description: 'Name of red color',
		defaultMessage: 'Red',
	},
	orange: {
		id: 'company-hub.color-picker.orange',
		description: 'Name of orange color',
		defaultMessage: 'Orange',
	},
	yellow: {
		id: 'company-hub.color-picker.yellow',
		description: 'Name of yellow color',
		defaultMessage: 'Yellow',
	},
	lime: {
		id: 'company-hub.color-picker.lime',
		description: 'Name of lime color',
		defaultMessage: 'Lime',
	},
	green: {
		id: 'company-hub.color-picker.green',
		description: 'Name of green color',
		defaultMessage: 'Green',
	},
	teal: {
		id: 'company-hub.color-picker.teal',
		description: 'Name of teal color',
		defaultMessage: 'Teal',
	},
	boldGray: {
		id: 'company-hub.color-picker.bold-gray',
		description: 'Name of bold gray color',
		defaultMessage: 'Bold gray',
	},
	boldBlue: {
		id: 'company-hub.color-picker.bold-blue',
		description: 'Name of bold blue color',
		defaultMessage: 'Bold blue',
	},
	boldPurple: {
		id: 'company-hub.color-picker.bold-purple',
		description: 'Name of bold purple color',
		defaultMessage: 'Bold purple',
	},
	boldMagenta: {
		id: 'company-hub.color-picker.bold-magenta',
		description: 'Name of bold magenta color',
		defaultMessage: 'Bold magenta',
	},
	boldRed: {
		id: 'company-hub.color-picker.bold-red',
		description: 'Name of bold red color',
		defaultMessage: 'Bold red',
	},
	boldOrange: {
		id: 'company-hub.color-picker.bold-orange',
		description: 'Name of bold orange color',
		defaultMessage: 'Bold orange',
	},
	boldYellow: {
		id: 'company-hub.color-picker.bold-yellow',
		description: 'Name of bold yellow color',
		defaultMessage: 'Bold yellow',
	},
	boldLime: {
		id: 'company-hub.color-picker.bold-lime',
		description: 'Name of bold lime color',
		defaultMessage: 'Bold lime',
	},
	boldGreen: {
		id: 'company-hub.color-picker.bold-green',
		description: 'Name of bold green color',
		defaultMessage: 'Bold green',
	},
	boldTeal: {
		id: 'company-hub.color-picker.bold-teal',
		description: 'Name of bold teal color',
		defaultMessage: 'Bold teal',
	},
	defaultBlue: {
		id: 'company-hub.color-picker.default-blue',
		description: 'Name of default blue color',
		defaultMessage: 'Default blue',
	},
});
